// extracted by mini-css-extract-plugin
export default {"tooltip":"Wo-z","sharingV2":"Xo-z","sharingIconsV2":"Yo-z","links":"Zo-z","link":"_o-z","facebookV2":"ap-z","twitterV2":"bp-z","pinterestV2":"cp-z"};